export default process.env.NODE_ENV;

export const MONTHS = [
	'Janvier',
	'Février',
	'Mars',
	'Avril',
	'Mai',
	'Juin',
	'Juillet',
	'Août',
	'Septembre',
	'Octobre',
	'Novembre',
	'Décembre'
];

export const MONTHS_SHORT = [
	'Jan.',
	'Fév.',
	'Mar.',
	'Avr.',
	'Mai',
	'Jun.',
	'Jui.',
	'Aoû.',
	'Sep.',
	'Oct.',
	'Nov.',
	'Déc.'
];